'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg4everybody = require('svg4everybody');

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVGLocal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SVGLocal, _Component);

  function SVGLocal() {
    (0, _classCallCheck3.default)(this, SVGLocal);
    return (0, _possibleConstructorReturn3.default)(this, (SVGLocal.__proto__ || (0, _getPrototypeOf2.default)(SVGLocal)).apply(this, arguments));
  }

  (0, _createClass3.default)(SVGLocal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _svg4everybody2.default)();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          link = _props.link,
          onClick = _props.onClick,
          viewBox = _props.viewBox;

      return _react2.default.createElement(
        'svg',
        { viewBox: viewBox, className: className, onClick: onClick },
        _react2.default.createElement('use', { xlinkHref: link })
      );
    }
  }]);
  return SVGLocal;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  link: _react.PropTypes.string.isRequired,
  onClick: _react.PropTypes.func,
  viewBox: _react.PropTypes.string.isRequired
}, _temp);
exports.default = SVGLocal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SVGLocal/SVGLocal.js
// module id = 1987
// module chunks = 0